export const IBaseTableDialogOptions = {
  endpoint: '',
  dropdown: {
    endpoint: '',
    filter: {},
    allLabel: 'All',
    placeholder: 'Select Category',
    payloadProperty: 'category_id',
    bind: {
      label: 'name',
      value: 'id',
      statusColor: 'colour',
      status: true,
    },
  },
  filter: {},
  noData: {
    title: '',
    description: '',
  },
  rowKey: 'item_id',
  columns: [{}],
}
